import React from 'react';

import classes from './Logo.module.css';

const logo = (props) => {
    //Log(props);
    let styleClasses = [classes.Logo];

    // props.topbarTheme === 'Dark' ? styleClasses.push(classes.Dark) : styleClasses.push(classes.Light);
    styleClasses.push(classes.Light)

    return (<div onClick={props.onLogoClick}>
        <div className={styleClasses.join(' ')}  >EDYODA</div>
        {props.isBlog ? <p className={classes.Stories}>Stories</p> : null}
    </div>
    );
};

export default logo;